import { render, staticRenderFns } from "./PromoEditor.vue?vue&type=template&id=a3fff80e&scoped=true"
import script from "./PromoEditor.vue?vue&type=script&lang=js"
export * from "./PromoEditor.vue?vue&type=script&lang=js"
import style0 from "./PromoEditor.vue?vue&type=style&index=0&id=a3fff80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fff80e",
  null
  
)

export default component.exports